import { z } from 'zod'

const ProxySelectRegistrationItemSchema = z.object({
  id: z.string(),
  selectMasterId: z.string(),
  optionIds: z.array(z.number()),
})

export const ProxySelectRegistrationFormEntitySchema = z.object({
  items: z.array(ProxySelectRegistrationItemSchema),
})

export type ProxySelectRegistrationItemEntity = z.infer<typeof ProxySelectRegistrationItemSchema>
export type ProxySelectRegistrationFormEntity = z.infer<
  typeof ProxySelectRegistrationFormEntitySchema
>
